Router = {
    url:'',
    path:'',
    pathArray: [],
    page: '',
    subpage: '',
    params: '',

    init: function(){
        if(typeof Editor != "undefined") return;
        History.Adapter.bind(window,'statechange',function(){ 
            var State = History.getState(); 
            Router.parseUrl();
        });
        // Router.parseUrl();
    },

    bindAnchors: function(collection){

        collection = collection ? collection : $('body');

        collection.find($('a:not([href^="http"])').not('.not-nav, .chosen-single, [href^="mailto"], [href^="tel"], [target="_blank"]')).click(function(event) {
            event.preventDefault();

            var url = $(this).attr('href');
            var title = $(this).attr('title');
            History.pushState({state:2}, title, url);

        })
    },

    parseUrl: function(){
        if(typeof Editor != "undefined") return;
        // console.log('parse URL:', window.location.href.replace(WEB_ROOT+"/", ""));
        
        Router.url = window.location.href;
        Router.path = Router.url.replace(WEB_ROOT+"/", "");
        Router.pathArray = Router.path.split("/");

        Router.page =  Router.pathArray[0];
        Router.subpage =  Router.pathArray[1];
        Router.params =  Router.pathArray[2];

        this.sendGaPageView();
        this.setSelected();
        Page.load($('[component="page"]').first(), Router.path);

        // if(!Directory.userScrolling)
        //     this.gotoPage();

    },

    //Manually trigger pageView on GA
    sendGaPageView: function(){
        if(!window.ga)
            return
        ga('gtm1.set', 'page', location.pathname)
        ga('gtm1.send', 'pageview')
    },

    route: function(title, url){
        // console.log(Directory.isScrolling);
        if(!Directory.isScrolling)
            History.pushState({state:2}, title, WEB_ROOT + "/" + url);
    },

    setSelected: function(){

        var webRoot = "/";
        
        var url = webRoot + Router.path;
        var firstLevel = webRoot + Router.path.split("/")[0];


        $('.navigation').find('.selected').removeClass('selected');
        $('.navigation').find('a[href="' + firstLevel + '"]').parent('.item').addClass('selected');
        // $('.navigation').find('a[href="' + url + '"]').parentsUntil("nav.main", '.item').addClass('selected');

        $('.button').removeClass('selected');
        $('.button[href="' + url + '"]').addClass('selected');

        // $('.tabs').find('.selected').removeClass('selected');
        // $('.tabs').find('a[href="' + url + '"]').addClass('selected');

        this.setDirection(url);

    },

    setDirection: function(url){

        var newDirection = $('[direction][href="' + url + '"]').attr('direction');

        if(newDirection){
            $('[component="page"]').attr('direction', newDirection);
        } else {
            $('[component="page"]').removeAttr('direction')
        }
    },

    gotoPage: function(){

        //Selector for current Page
        Page.current = $('.row[url^="' + Router.page + '"]').first();

        // url has changed Router has new URL
        //TODO - zglobalizovať neskôr, teraz sa zatiaľ sa vyzužíva len v tejto funckcii
        var hasDifferentUrl = Page.current.attr('url') != Router.path;

        // It is present on Direcory, so scrolling is needed
        // TO-DO pre neskrolovacie stránky bezpredmetné
        var isHere = Page.current.length;

        // Check if title page is loaded
        // TODO - zbaviť sa prázdnych url ... url titulky musí byť "/" báj dizájn
        var isTitle = Router.page == "";

        // Loadeed page is not page from Directory, it's a subpage 
        var isSubpage = Router.subpage;

        // Open page. A subpage loaded by ajax, or loaded Direcory page by refresh
        var isOpened = Page.current.attr('state') == "open";

        if(App.debug){
            console.log('--- Router.gotoPage -----------------------------');
            console.log('Router.path', Router.path);
            console.log('Page.current', Page.current);
            console.log('isHere', isHere);
            console.log('hasDifferentUrl', hasDifferentUrl);
        }

        // I'm using Direcotry but user clicked on Homepage
        // Ak sa podarí dať titulke reálne url "/", vymazať
        if(App.hasDirectory && isTitle){
            Directory.scroll(0);

            if($('[page="homepage"]').attr('url')){
                Homepage.reset();
            }

            if (Directory.openPageEl.length)
                Directory.resetPage();
                Directory.closePage();
            return;
        }


        // I'm using Direcotry and requested Page is in Directory
        if(App.hasDirectory && isHere){

            // len pre popup style
            if(Page.hasPopup && !isSubpage){
                Page.closePopup();

                $('[component="directory"] > .os-scrollbar').removeAttr('style');
                $('[component="directory"] > .os-padding > .os-viewport').css({overflowY: 'scroll'});
                Scroller.el.update();
            }

            //ak refresnuta stranka je popup
            if ($('[type="popup"]').not('.hide').length) {
                $('[type="popup"]').not('.hide').addClass('show');
                Page.hasPopup = true;
                Scroller.el.sleep();
                $('[component="directory"] > .os-scrollbar').css({display: 'none'});
                $('[component="directory"] > .os-padding > .os-viewport').css({overflowY: 'hidden'});
            } 

            Directory.openPageEl = $('.row[state="open"]').first();

            if (hasDifferentUrl) {
                Page.load(Page.current, Router.path);
            }else{
                Directory.scrollToPage(Router.page,0);
            }

            if(isSubpage){
                setTimeout(function(){
                    Directory.openPage(Page.current);
                },500)
                
            }
        }

        if(App.hasDirectory && !isHere){
             Page.load($('.row[url]').first(), Router.path);
        }

        // I'm not using Direcory and url has changed
        if (!App.hasDirectory && hasDifferentUrl) {
            Page.load($('.row[url]').first(), Router.path);
        }

        

    },

    redirect: function(){
        if(App.debug){
            console.log('--- Router.redirect -----------------------------')
            console.log('Router', Router);
        }
        window.location.href = Router.url;
    },

    // not used
    show404: function(){
        if(App.debug){
            console.log('--- Router.show404 -----------------------------')
        }
        window.location.href = WEB_ROOT + "/404";
    },
}
